import { getKeyValue } from 'Src/i18n';
import { LOCALES } from './constants';

const isChineseLocale = (locale?: string): boolean =>
  locale === LOCALES.EN_CN || locale === LOCALES.ZH_CN;

const isLocaleToDisplayDidomi = (): boolean => getKeyValue('common.activateDidomi');

export { isChineseLocale, isLocaleToDisplayDidomi };
